import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-961cca1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "role-info-model",
  ref: "roleModel"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-close" }, null, -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "order" }
const _hoisted_5 = { class: "status" }

import {
  reactive, withDefaults, ref, watch, computed,
} from 'vue';
import { useStore, } from 'vuex';
import {
  Modal, Button, Table, ConfigProvider, Switch,
} from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';

interface Props {
  infoVisible?: boolean,
  roleUser: any,
}

type ColumnType = {
  title: string;
  align?: string,
  dataIndex?: string;
  slots?: any;
  width?: any;
  ellipsis?: any;
};

// 列表行配置

export default /*#__PURE__*/_defineComponent({
  props: {
    infoVisible: { type: Boolean, default: false },
    roleUser: { default: {} }
  },
  emits: [
  'info-cancal',
  'info-confirm',
  'sizeChange',
],
  setup(__props: any, { emit: emits }) {

const props = __props as { infoVisible: boolean, roleUser: any }

const store = useStore();



const columns: ColumnType[] = [
  {
    title: '序号',
    slots: { customRender: 'index', },
    width: '4%',
  },
  {
    title: '用户名',
    dataIndex: 'name',
    ellipsis: true,
    width: '6%',
  },
  {
    title: '组织名',
    dataIndex: 'company',
    ellipsis: true,
    width: '6%',
  },
  {
    title: '部门',
    dataIndex: 'dept',
    ellipsis: true,
    width: '5%',
  },
  {
    title: '职位',
    dataIndex: 'position',
    ellipsis: true,
    width: '5%',
  },
  {
    title: '角色',
    dataIndex: 'roleName',
    ellipsis: true,
    width: '5%',
  },
  {
    title: '手机号/账号',
    dataIndex: 'tel',
    ellipsis: true,
    width: '8%',
  },
  {
    title: '账号',
    dataIndex: 'accountName',
    ellipsis: true,
    width: '5%',
  },
  {
    title: '创建人',
    dataIndex: 'creator',
    ellipsis: true,
    width: '5%',
  },
  {
    title: '账号创建时间',
    dataIndex: 'createTime',
    ellipsis: true,
    width: '10%',
  },
  {
    title: '账号到期时间',
    dataIndex: 'expirationTime',
    ellipsis: true,
    width: '10%',
  },
  {
    title: '工单账号',
    align: 'center',
    dataIndex: 'isOrderAccept',
    slots: { customRender: 'order', },
    width: '6%',
  },
  {
    title: '账号状态',
    align: 'center',
    dataIndex: 'isFrozen',
    slots: { customRender: 'status', },
    width: '6%',
  },
];



// 表格数据
const tableData = ref<any>([]);

// 当前页面
const current = ref<number>(1);
// 数据总数
const total = ref<number>(0);
// 选中的行
const selectedKeys = ref<any[]>([]);
// 列表数据
const userInfoList = computed(() => store.state.userCenter.userInfoList);

watch(userInfoList, (val) => {
  tableData.value = val;
  total.value = val.length;
},{
  deep: true,
});

const handleChange = (page: any, pageSize: any) => {
  current.value = page;
  emits('sizeChange', { pageNum: page, pageSize, });
};

const handleCancle = ():void => {
  emits('info-cancal');
};

const handleSave = () => {
  emits('info-confirm');
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Modal), {
      getContainer: () => _ctx.$refs.roleModel,
      title: "角色详情",
      width: '18.4rem',
      footer: false,
      visible: props.infoVisible,
      onCancel: handleCancle
    }, {
      closeIcon: _withCtx(() => [
        _hoisted_2
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(ConfigProvider), { locale: _unref(zhCN) }, {
            default: _withCtx(() => [
              _createVNode(_unref(Table), {
                columns: columns,
                pagination: {
              total: __props.roleUser.total,
              pageSize: 10,
              size:'small',
              current: __props.roleUser.pageNum,
              showQuickJumper: true,
              showTotal: () => `共 ${__props.roleUser.total} 条`,
              onChange: (page, pageSize) => handleChange(page, pageSize),
            },
                scroll: {
              y: '4.8rem'
            },
                "data-source": tableData.value
              }, {
                index: _withCtx(({ index,}) => [
                  _createElementVNode("span", null, _toDisplayString(index + 1), 1)
                ]),
                order: _withCtx(({ text }) => [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(text === '1' ? '启用' : '禁用'), 1)
                ]),
                status: _withCtx(({ text }) => [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(text === '1' ? '启用' : '禁用'), 1)
                ]),
                _: 1
              }, 8, ["pagination", "scroll", "data-source"])
            ]),
            _: 1
          }, 8, ["locale"])
        ]),
        _createElementVNode("div", { class: "operation" }, [
          _createElementVNode("button", {
            class: "btn cancle",
            onClick: handleCancle
          }, "取消"),
          _createElementVNode("button", {
            class: "btn",
            onClick: handleSave
          }, "确认")
        ])
      ]),
      _: 1
    }, 8, ["getContainer", "width", "visible"])
  ], 512))
}
}

})